import "./StepFooter.css";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

const StepFooter = ({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  nextDisabled = false,
  nextLabel // wird von Step 7 übergeben (z. B. "Absenden")
}) => {

  const { texts } = useContext(LanguageContext);

  const isFirst = currentStep === 1;
  const isLast = currentStep === totalSteps;

return (
  <div className="step-footer-wrapper">
    <div className="step-footer-menu">

      {isFirst ? (
        <div className="step-footer-placeholder"></div>
      ) : (
        <button
          className="step-footer-object-button"
          onClick={onBack}
        >
          {texts.common.back}
        </button>
      )}

      <button
        className={`step-footer-object-button next-button ${
          nextDisabled ? "disabled" : "active"
        }`}
        onClick={onNext}
        disabled={nextDisabled}
      >
        {isLast ? (nextLabel || texts.common.submit) : texts.common.next}
      </button>

    </div>
  </div>
);

};

export default StepFooter;
